'use client';
import { Tab } from '@headlessui/react';
import { Entering } from 'components';

import {
  cloneElement,
  FC,
  Fragment,
  HTMLAttributes,
  ReactElement,
  ReactNode,
  useState
} from 'react';
import { cn } from 'utils/cn';
import TabCustomToggle from './TabCustomToggle';

interface ITabToggle extends Omit<HTMLAttributes<HTMLElement>, 'children'> {
  /**
   * Text contents
   */
  isActive?: boolean;
  /**
   * Tabs contents
   */
  tabs: {
    label: ReactNode;
    className?: '';
    onClick?: (index?: number) => void;
    href?: string;
    hash?: string;
  }[];
  /**
   * Button disabled
   */
  disabled?: boolean;
  /**
   * Optional click handler
   */
  onClick?: () => void;
  /**
   * classNameGroup
   */
  noRedirect?: boolean;
  /**
   * classNameGroup
   */
  classNameGroup?: string;
  /**
   * Children custom
   */
  children?:
    | ReactElement<{ selectedIndex: number }>
    | ((props: { selectedIndex: number }) => ReactElement);
}
[];

const TabToggle: FC<ITabToggle> = ({ tabs, children, classNameGroup, ...rest }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const isFunctionChildren = typeof children === 'function';

  return (
    <div className={'mt-6'} {...rest}>
      {!!tabs?.length && (
        <Entering offset={5} delay={0.4} duration={0.2} position="top" className={classNameGroup}>
          <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
            <Tab.List className={cn('mb-0 flex gap-1 rounded-md bg-tertiary-800 p-1 ')}>
              {tabs.map(({ label, href, onClick }, index) => (
                <Fragment key={label + 'tab-custom-toggle' + index}>
                  <TabCustomToggle index={index} label={label} href={href} onClick={onClick} />
                </Fragment>
              ))}
            </Tab.List>
          </Tab.Group>
        </Entering>
      )}
      {!!tabs?.length && (
        <>
          {isFunctionChildren && <>{children({ selectedIndex })}</>}
          {!isFunctionChildren && <>{cloneElement(children ?? <></>, { selectedIndex })}</>}
        </>
      )}
    </div>
  );
};

export default TabToggle;
